export default __webpack_public_path__ + "static/media/undraw_empty_xct9.21839dcc.svg";